module.exports = {
      id: "newsletter_black-usage",
      viewBox: "0 0 14 16",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#newsletter_black",
      toString: function () {
        return this.url;
      }
    }